@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.combine-customers-modal {
  width: 1000px;
  margin: 30px 0;
}

.combine-customers-modal-body {
  height: 400px;
  padding: 15px;
  font-size: 13px;
  line-height: 1.42;
  color: @customer-page--modal--text-color;
}

.combine-customers-section-divider {
  margin-bottom: 10px;
  margin-top: 10px;
}

.combine-button {
  display: flex;

  .combine {
    width: 15px;
    height: 15px;
    margin: auto 5px auto 0;
  }
}
